<template>
  <el-dialog
    top="10vh"
    width="1400px"
    class="custom-libary"
    :visible="true"
    :title="$t('自定义库')"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <HTForm v-bind="formOptions" :i18nPath="i18nPath"></HTForm>

    <MTable
      :i18nPath="i18nPath"
      :loading="loading"
      :tableData="tableData"
      :tableColumn="tableColumn"
      :pagiOption="pagiOption"
      :oprateMenu="oprateMenu"
      max-height="calc(100% - 60px)"
      v-on:search="search"
      style="height: calc(100% - 60px)"
    ></MTable>

    <AddMat
      :visible.sync="addMatVisible"
      @saved="search"
      :is-details="isDetails"
      :sn="sn"
      :id="addMatId"
    />

    <!-- <SampleDialog :visible.sync="sampleVisible" :sn="sn" :id="sampleId"></SampleDialog> -->
  </el-dialog>
</template>

<script>
import HTForm from '@/components/form';
import MTable from '@/components/mTable/m-table';

import AddMat from './add-mat.vue';

import { delFcbrMatById, getFcbrMatList, getFcbrMatDetails } from '@/api/material';

import { awaitTo } from '@/utils/utils';
import { formatTime } from '@/utils/date';

import { cfrSampleStatusUtils, matOptions, matUitls } from './utils';

import { showCollSampleDialog } from './index.js';

import { useDialog } from '@/components/dialog/index';
import { isString } from '@/utils/is';

export default {
  components: {
    HTForm,
    MTable,
    AddMat
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    return {
      addMatVisible: false,
      addMatId: undefined,
      isDetails: false,

      loading: false,
      i18nPath: 'fcbr100pro',
      formOptions: {
        inline: true,
        config: {
          labelWidth: '',
          span: 6,
          options: [
            {
              type: 'input',
              attrs: { clearable: true },
              prop: 'matName',
              placeholder: '请输入物质名称',
              label: '物质名称'
            },
            {
              type: 'select',
              prop: 'matType',
              placeholder: '请选择物质类型',
              label: '物质类型',
              dataKey: 'matOptions',
              attrs: { clearable: true }
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '查询',
                loading: false,
                type: 'primary',
                handler: async ({ setLoading }) => {
                  setLoading(true);
                  this.pagiOption.offset = 1;
                  await this.search();
                  setLoading(false);
                }
              },
              {
                text: '新增',
                loading: false,
                type: 'primary',
                handler: async () => {
                  this.isDetails = false;
                  this.addMatId = undefined;
                  this.addMatVisible = true;
                }
              }
            ]
          }
        },
        model: {
          matName: '',
          matType: ''
        },
        dataSource: {
          matOptions
        },
        rules: {}
      },
      tableData: [],
      tableColumn: [
        { prop: 'matName', label: '物质名称' },
        {
          prop: 'matType',
          width: '200px',
          label: '物质类型',
          temp: ({ row }) => matUitls.getStateText(row.matType)
        },
        {
          prop: 'status',
          label: '状态',
          width: '200px',
          temp: ({ row }) => cfrSampleStatusUtils.getStateText(row.status)
        },
        {
          prop: 'createDate',
          label: '创建时间',
          temp: ({ row }) => formatTime(+row.createDate)
        }
      ],
      oprateMenu: {
        label: '操作',
        width: '250px',
        list: [
          {
            text: '采样',
            access: () => true,
            event: (_index, data) => {
              showCollSampleDialog({
                sn: this.sn,
                id: data.id,
                closeCallback: () => {
                  this.search();
                }
              });
            }
          },
          {
            text: '谱图',
            access: () => true,
            event: async (_index, data, loading) => {
              const btn = loading();

              btn.open();
              await this.openMatDetails(data.id);
              btn.close();
            }
          },
          {
            text: '详情',
            access: () => true,
            event: (_index, data) => {
              this.isDetails = true;
              this.addMatId = data.id;
              this.addMatVisible = true;
            }
          },
          {
            text: '修改',
            access: () => true,
            event: (_index, data) => {
              this.isDetails = false;
              this.addMatId = data.id;
              this.addMatVisible = true;
            }
          },
          {
            text: '删除',
            access: () => true,
            event: async (_index, data, loading) => {
              const btn = loading();

              btn.open();

              const [err, res] = await awaitTo(
                this.$confirm(this.$t('确认删除吗?'), this.$t('提示'), {
                  confirmButtonText: this.$t('确定'),
                  cancelButtonText: this.$t('取消'),
                  type: 'warning'
                })
              );

              if (err || res !== 'confirm') return btn.close();

              await this.delMat(data.id);

              btn.close();
            }
          }
        ]
      },
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      done?.();
    },
    async search() {
      this.loading = true;

      const [err, res] = await awaitTo(
        getFcbrMatList({
          sn: this.sn,
          matName: this.formOptions.model.matName,
          matType: this.formOptions.model.matType,
          limit: this.pagiOption.limit,
          offset: this.pagiOption.offset
        })
      );

      this.loading = false;

      if (err) {
        this.$message.error(err?.message);
      }

      if (res) {
        this.pagiOption.total = res.data.total;
        this.tableData.splice(0, Infinity, ...res.data.list);
      }
    },
    async delMat(id) {
      const [err, res] = await awaitTo(delFcbrMatById(id));

      if (err) {
        this.$message.error(err?.message);

        return false;
      }

      if (res) {
        this.search();
      }
    },
    async openMatDetails(id) {
      const [err, res] = await awaitTo(getFcbrMatDetails({ id }));

      if (err) {
        console.log(err);
        this.$message.warning(this.$t('获取图谱信息失败'));
        return false;
      }

      let data = [];

      if (isString(res?.data?.resChannelsNormalVector)) {
        data = res.data.resChannelsNormalVector.split(',').map(e => +Number(e).toFixed(4));
      }

      const options = {
        color: ['#04d7ff'],
        tooltip: {
          trigger: 'axis',
          show: true
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#04d7ff'
            }
          },
          data: Array(16)
            .fill()
            .map((_, i) => `通道 ${i + 1}`)
        },
        yAxis: {
          type: 'value',
          // max(v) {
          //   if (v.max > 0) {
          //     return Math.ceil((v.max * 12) / 10).;
          //   } else if (v.max === 0) {
          //     return v.max + 0.0001;
          //   } else {
          //     return Math.ceil((v.max * 8) / 10);
          //   }
          // },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#04d7ff'
            }
          }
        },
        series: [
          {
            data,
            type: 'line'
          }
        ]
      };

      useDialog({
        title: this.$t('物质谱图'),
        width: '70vw',
        slots: {
          default: () => (
            <div style="height:45vh;">
              <v-chart options={options} autoresize={true}></v-chart>
            </div>
          )
        }
      });

      return true;
    }
  },
  mounted() {
    document.body.appendChild(this.$el);

    this.$nextTick(() => {
      this.search();
    });
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.custom-libary {
  box-sizing: border-box;

  .el-dialog {
    max-width: 80%;
    height: calc(100vh - 20vh);

    &__body {
      height: calc(100% - 55px);
      box-sizing: border-box;
    }

    .m-table {
      height: calc(100% - 60px);

      .el-table {
        height: calc(100% - 55px);

        &__body-wrapper {
          height: calc(100% - 48px);
        }
      }
    }
  }
}
</style>
